import Head from 'next/head';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
// import Feed from 'components/Feed';
export async function getStaticProps({ locale }) {
  console.log('loading translation for', locale);

  return {
    props: {
      ...(await serverSideTranslations(locale, ['common', 'menus'])) // 'menus' is used for component translation and common for page translation itself.
    }
  };
}
const meta = {
  // title: 'AI Interior Design App| Virtual Home Staging Software | Best for Interior Designers and Real Estate Agents',
  description:
    'Learn more about our Affiliate Program. Earn 20% commission on every sale you refer to SnapLuna.',
  cardImage:
    'https://imagedelivery.net/_KeVhvb2O4eJIzSpK4wEFQ/7d8a687b-e135-43b5-0f8e-a22db6be6b00/free'
};

import FaqComp from '../components/FaqComp';

const faqs = [
  {
    key: '1234',
    question: 'What is the snapluna Affiliate Program?',
    answer: `<p>Our affiliate program allows you to earn money by promoting snapluna and referring new customers to us. You get an ongoing 20% commission of whatever we make with the affiliated users.</p>
    `
  },
  {
    key: '123wdwds4',
    question: 'Can I run paid ads on my affiliate link?',
    answer:
      '<p>Yes, but you have to follow the rules that are part of our Terms & Conditions. Affiliate users shall not use the keyword "snapluna" in ads, nowhere in an ad copy - title or body text. Affiliate users can’t use the keyword "snapluna" within online ad campaigns (including, without limitation, within metadata or search-based advertising such as Google Adwords) without prior written consent from snapluna.</p>'
  },
  {
    key: 'badad1234',
    question: 'How to get paid? Is there a minimum payout?',
    answer:
      'The minimum threshold is $50. We send you your commission through a Wise or PayPal transfer. Rewards are being paid out every month.'
  },
  {
    key: 'b1234',
    question: 'Can I monitor my commissions?',
    answer:
      'Yes. You will always have access to your affiliate panel with advanced reports to monitor your progress, commissions and payouts.'
  },
  {
    key: 'b1234fafwfw',
    question: 'Who can participate in the program?',
    answer:
      'Anyone can become an affiliate. Our affiliates come from all industries. You will most likely be successful if you are a marketing consultant, agency, blogger, thought leader or a freelancer.'
  },
  {
    key: 'b1234fafwfw',
    question:
      'Someone I referred did not use my affiliate link. Can you add the user to my affiliate account?',
    answer:
      'No, unfortunately, this isn’t possible. The new user must use your unique affiliate link when registering in order to be added to your affiliate account.'
  },
  {
    key: 'b1234fafwfw',
    question: 'How long does the cookie last?',
    answer:
      'Visitors have 30 days to sign up for snapluna after clicking on your affiliate link.'
  },
  {
    key: 'b1234fafwfw',
    question: 'Can I refer my own account?',
    answer: "No, you can't refer yourself."
  }
];

export default function PricingPage({ products }) {
  return (
    <div>
      <Head>
        {/* <title>{meta.title}</title> */}
        <meta
          name="description"
          content={meta.description}
          key="main_description"
        />
      </Head>

      <div className="mb-16">
        <div className="sm:flex sm:flex-col mt-16 mx-4 sm:align-center flex flex-col items-center">
          <h1 className="text-3xl font-extrabold text-slate-900 text-center sm:text-6xl">
            Become a snapluna Affiliate
          </h1>
          <p className="mt-2 text-lg text-slate-800 sm:text-xl max-w-2xl m-auto text-center">
            Get paid to promote snapluna. Join our affiliate program and earn
            20% recurring commissions for lifetime.
          </p>
          <a
            className="bg-[#4138C2] text-white py-2 px-3 mt-4 text-xl hover:bg-black"
            href="https://snapluna.getrewardful.com/signup"
          >
            Get Started
          </a>
        </div>
        <div className="flex flex-col items-center mx-4">
          <h1 className="font-extrabold mt-24 text-5xl">How it Works</h1>
          <div className="flex flex-col gap-y-5 sm:flex-row max-w-5xl mt-14">
            <div className="flex flex-col items-center gap-y-4 text-center">
              <div className="bg-[#4138C2] text-white text-3xl px-6 py-3">
                1
              </div>
              <h2 className="font-extrabold text-2xl"> ✍️ Join the Program</h2>
              <p className="text-slate-700 font-bold">
                Sign up for our affiliate program and get your unique referral
                link.
              </p>
            </div>
            <div className="flex flex-col items-center gap-y-4 text-center">
              <div className="bg-[#4138C2] text-white text-3xl px-6 py-3">
                2
              </div>
              <h2 className="font-extrabold text-2xl"> 📢 Promote snapluna</h2>
              <p className="text-slate-700 font-bold">
                Create content and send visitors to snapluna using your unique
                link.
              </p>
            </div>
            <div className="flex flex-col items-center gap-y-4 text-center">
              <div className="bg-[#4138C2] text-white text-3xl px-6 py-3">
                3
              </div>
              <h2 className="font-extrabold text-2xl"> 💰Earn rewards</h2>
              <p className="text-slate-700 font-bold">
                Earn 20% commission & enjoy your passive recurring income for
                lifetime.
              </p>
            </div>
          </div>
        </div>
        <div className="flex flex-col items-center">
          <h1 className="font-extrabold mt-16 text-4xl">
            How Much Can I Earn?
          </h1>
          <p className="mt-2 text-lg text-slate-500 sm:text-xl max-w-2xl m-auto text-center mb-5">
            Here is how much you earn in 1 year if you refer 10 paying users on
            these plans:
          </p>
          <ul className="flex flex-col gap-2">
            <li>
              snapluna Pro (Monthly Plan):{' '}
              <span className="font-extrabold">$700</span>
            </li>
            <li>
              snapluna Teams (Monthly Plan):{' '}
              <span className="font-extrabold">$7,180</span>
            </li>
            <li>
              snapluna Pro (Yearly Plan):{' '}
              <span className="font-extrabold">$500</span>
            </li>
            <li>
              snapluna Teams (Yearly Plan):{' '}
              <span className="font-extrabold">$4,000</span>
            </li>
          </ul>
          <a
            className="bg-[#4138C2] text-white py-2 px-3 mt-6 text-xl hover:bg-black "
            href="https://snapluna.getrewardful.com/signup"
          >
            Get Started
          </a>
        </div>
        <div className="flex flex-col items-center">
          <h1 className="font-extrabold mt-16 text-4xl">FAQ</h1>
          <FaqComp faqs={faqs} />
        </div>
        <div className="flex flex-col items-center max-w-5xl mx-auto px-4">
          <h1 className="font-extrabold mt-16 text-4xl mx-12 mb-10 ">
            Terms of Service for the Affiliate Program
          </h1>
          <p>
            There are a few rules about our affiliate program you should know
            about. No "gotchas" here, just some terms to keep everyone happy.
          </p>
          <ul className="ml-10 flex flex-col gap-3 mt-2 list-disc">
            <li className="">
              Self-referrals are not allowed (i.e. signing up for snapluna
              through your own affiliate link).
            </li>
            <li>
              Abuse, gaming, or attempting to mislead (i.e. posting fake
              discounts to coupon-sharing websites) will result in your account
              being permanently banned.
            </li>
            <li>
              In some cases, we can give credit to an affiliate even if the
              customer didn’t sign up through an affiliate link or coupon code.
              If you have a case like this, please contact us and we’ll do our
              best to help.
            </li>
            <li>
              No search engine ads (especially on branded terms or domain
              names), Facebook ads or other ads that would compete with our own
              marketing and cause potential confusion for customers.
            </li>
            <li>
              No Facebook ads that link to our website or anything similar that
              would compete with our own paid marketing and drive up our costs
              and potentially cause confusion.
            </li>
            <li>
              No pretending to be acting on behalf of us (ie. as an employee).
            </li>
            <li>
              We reserve the right to change the Terms of Service for our
              affiliate program at any time.
            </li>
            <li>
              We reserve the right to terminate your affiliate account for
              violation of any of the rules at our sole discretion. Commissions
              generated by mechanisms that are in violation of our Terms of
              Service will not be paid or owed.
            </li>
          </ul>
          <p className="font-extrabold text-4xl mt-10">Commission payment</p>
          <p className="self-start mt-2">snapluna commissions are paid:</p>
          <ul className="list-disc self-start ml-5">
            <li>Monthly (usually on the 5th).</li>
            <li>Via PayPal transfer</li>
            <li>
              In order to receive payment, you must provide a valid PayPal email
              address. The minimum threshold is $50.
            </li>
          </ul>
          <a
            className="bg-[#4138C2] text-white py-2 px-3 mt-6 text-xl hover:bg-black "
            href="https://snapluna.getrewardful.com/signup"
          >
            Get Started
          </a>
        </div>
      </div>
    </div>
  );
}
